import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { SponsorsCompact } from './Sponsors';
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: '1. Aceptación de los Términos',
    body: 'Al adquirir la Guía Completa de Anticonceptivos Orales (en adelante, "el Producto"), aceptas íntegramente los presentes Términos y Condiciones. Si no estás de acuerdo con alguno de ellos, te pedimos no completar la compra.'
  }, {
    heading: '2. Naturaleza del Producto',
    body: 'El Producto es un material digital descargable en formato PDF, de carácter exclusivamente educativo e informativo. NO constituye consejo, diagnóstico ni tratamiento médico. La información contenida está basada en guías públicas de la OMS, CDC y literatura médica disponible, pero no reemplaza la consulta con un profesional de la salud calificado.'
  }, {
    heading: '3. Licencia de Uso',
    body: 'La compra otorga al usuario una licencia personal, intransferible y no exclusiva para descargar, leer e imprimir el Producto para uso individual. Queda estrictamente prohibida la reventa, redistribución, reproducción total o parcial, publicación en redes, plataformas o sitios web, o cualquier uso comercial del contenido sin autorización expresa por escrito.'
  }, {
    heading: '4. Entrega Digital',
    body: 'La entrega del Producto se realiza de forma electrónica e inmediata tras la confirmación del pago, mediante un enlace de descarga. Es responsabilidad del usuario proporcionar un correo electrónico válido y conservar el archivo descargado.'
  }, {
    heading: '5. Política de Reembolso',
    body: 'Ofrecemos una garantía de devolución de 7 días naturales contados a partir de la fecha de compra. Si el Producto no cumple tus expectativas, puedes solicitar el reembolso del 100% del importe pagado dentro de ese plazo. Pasados los 7 días no se aceptarán solicitudes de devolución, dado el carácter digital e inmediato del producto.'
  }, {
    heading: '6. Propiedad Intelectual',
    body: 'Todos los textos, gráficos, diseños, calendarios, checklists y demás elementos del Producto están protegidos por derechos de autor. Cualquier uso no autorizado podrá ser perseguido conforme a la legislación vigente.'
  }, {
    heading: '7. Limitación de Responsabilidad',
    body: 'El Producto se ofrece "tal cual", con fines educativos. No nos hacemos responsables de decisiones médicas, efectos en la salud o consecuencias derivadas del uso o interpretación de la información contenida. Siempre debes consultar a tu médico o ginecólogo ante cualquier duda relacionada con tu salud o tu método anticonceptivo.'
  }, {
    heading: '8. Modificaciones',
    body: 'Nos reservamos el derecho de actualizar o modificar estos Términos y Condiciones en cualquier momento. Las modificaciones entrarán en vigor desde su publicación en esta página.'
  }, {
    heading: '9. Privacidad',
    body: 'Los datos proporcionados durante la compra (nombre, correo electrónico, información de pago) serán utilizados únicamente para procesar el pedido y entregar el Producto. No compartimos, vendemos ni cedemos información personal a terceros.'
  }, {
    heading: '10. Legislación Aplicable',
    body: 'Estos Términos y Condiciones se rigen por la legislación vigente en el país de operación del vendedor. Cualquier controversia será resuelta conforme a dicha normativa.'
  }],
  footer: 'Última actualización: 2024. Al completar tu compra confirmas haber leído y aceptado estos Términos y Condiciones. 💜'
};
export function Footer() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <footer className="bg-white py-12 px-4 sm:px-6 lg:px-8 border-t border-brand-cardPink/50 mt-12" data-id="element-62">
      <div className="max-w-4xl mx-auto text-center" data-id="element-63">
        <SponsorsCompact data-id="element-64" />

        <div className="bg-brand-bg rounded-[16px] p-6 mb-8 border border-brand-cardPink" data-id="element-65">
          <p className="text-sm text-brand-secondary leading-relaxed" data-id="element-66">
            <span className="font-bold" data-id="element-67">Aviso legal:</span> Esta guía tiene
            fines educativos únicamente. No reemplaza el diagnóstico, consejo ni
            tratamiento médico profesional. Ante cualquier duda consulta a tu
            médico. 💜
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-secondary font-medium mb-8" data-id="element-68">
          <button onClick={() => setOpen(true)} className="hover:text-brand-primary transition-colors underline-offset-4 hover:underline" data-id="element-69">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-sm text-gray-400" data-id="element-70">
          © 2024 Guía Anticonceptivos Premium. Todos los derechos reservados.
        </p>
      </div>

      <AnimatePresence data-id="element-71">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setOpen(false)} className="fixed inset-0 z-50 bg-brand-dark/60 backdrop-blur-sm flex items-center justify-center p-4" data-id="element-72">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-[24px] shadow-2xl max-w-2xl w-full max-h-[85vh] flex flex-col overflow-hidden" data-id="element-73">
              <div className="flex items-center justify-between px-6 sm:px-8 py-5 border-b border-brand-cardPink/50 bg-gradient-primary text-white" data-id="element-74">
                <h2 className="text-xl sm:text-2xl font-heading font-bold" data-id="element-75">
                  {termsContent.title}
                </h2>
                <button onClick={() => setOpen(false)} className="p-2 rounded-full hover:bg-white/20 transition-colors" aria-label="Cerrar" data-id="element-76">
                  <X className="w-5 h-5" data-id="element-77" />
                </button>
              </div>

              <div className="overflow-y-auto px-6 sm:px-8 py-6 text-left" data-id="element-78">
                <div className="space-y-6" data-id="element-79">
                  {termsContent.sections.map((section, i) => <div key={i} data-id="element-80">
                      <h3 className="font-bold text-brand-primary mb-2" data-id="element-81">
                        {section.heading}
                      </h3>
                      <p className="text-brand-secondary text-sm leading-relaxed" data-id="element-82">
                        {section.body}
                      </p>
                    </div>)}
                </div>

                <div className="mt-8 pt-6 border-t border-brand-cardPink/50" data-id="element-83">
                  <p className="text-xs text-brand-secondary italic text-center" data-id="element-84">
                    {termsContent.footer}
                  </p>
                </div>
              </div>

              <div className="px-6 sm:px-8 py-4 border-t border-brand-cardPink/50 bg-brand-bg/50 flex justify-end" data-id="element-85">
                <button onClick={() => setOpen(false)} className="bg-gradient-primary text-white font-body font-semibold py-2.5 px-6 rounded-full shadow hover:shadow-md transition-all" data-id="element-86">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}